/* eslint-disable import/no-default-export */
import {SideCartController} from './SideCartController';
import {controllerFactory as oldControllerFactory} from '@wix/wixstores-client-storefront-sdk';
import {conditionalController} from '../../domain/controllers/conditionalController';
import {SPECS} from '../../domain/specs';
import {ControllerConstructorType} from '../../types/app.types';
import {controllerFactory} from './controllerFactory';

export const conditionalSideCartControllerFactory = (controller: ControllerConstructorType<SideCartController>) =>
  conditionalController(
    SPECS.UseNewControllerFactoryInSideCart,
    controllerFactory(controller),
    oldControllerFactory(controller, {shouldSkipMultilingual: true})
  );

export default conditionalSideCartControllerFactory(SideCartController);
